export default __webpack_public_path__ + "static/media/Time_icon.58668e1d.svg";